import { render, staticRenderFns } from "./Confirmation.vue?vue&type=template&id=625d2beb&scoped=true&"
import script from "./Confirmation.vue?vue&type=script&lang=ts&"
export * from "./Confirmation.vue?vue&type=script&lang=ts&"
import style0 from "./Confirmation.vue?vue&type=style&index=0&id=625d2beb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625d2beb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
